import { useMemo } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import { useSelectContext } from '../../select'
import type {
  SelectHelperTextProps,
  SelectScopedProps,
} from '../../select.types'
import { selectHelperTextVariants } from './index.styles'

export const SelectHelperText = ({
  withIcon,
  iconName = 'rdicon-warning-circle',
  __scopeInputSelect,
  children,
  ...props
}: SelectScopedProps<SelectHelperTextProps>) => {
  const { hasError, readOnly, disabled } = useSelectContext(
    'InputSelectHelperText',
    __scopeInputSelect
  )

  const symbol = hasError ? 'rdicon-warning-circle' : iconName

  const iconColor = useMemo((): TIconProps['color'] => {
    if (disabled) return 'colorTextNeutralDisabled'
    if (readOnly) return 'colorTextNeutralReadonly'
    if (hasError) return 'colorTextDangerAlternative'
    return 'colorTextNeutralAlternative'
  }, [disabled, hasError, readOnly])

  if (!children) return null

  return (
    <div
      {...props}
      aria-disabled={disabled}
      className={selectHelperTextVariants({
        hasError,
        disabled,
        readOnly,
      })}
    >
      {withIcon && (
        <div className="flex items-center">
          <Icon symbol={symbol} color={iconColor} size="tiny" />
        </div>
      )}
      <span className="flex flex-1">{children}</span>
    </div>
  )
}
